import type { FilterInputData, FilterTemplate } from '@/shared/api/graphql/filters';
import { toTruentityDateInput } from '@/shared/lib/util/date';
import type { PatientFilter } from '@/shared/model/PatientFilterStore';

/** Converts a saved filter template (as returned by the API) into the patient list's filter shape. */
export function transformToPatientFilter(template: FilterTemplate): PatientFilter {
  const patientFilter: PatientFilter = {
    id: template.id,
    name: template.name,
    description: '',
    shared: false,
    filter: {
      onboardedOn: { start: null, end: null },
      organization: '',
      readmissionRisk: undefined,
      numberOfMeds: undefined
    }
  };

  template.filterTemplateAttributes.forEach(({ filterType, value, value2 }) => {
    switch (filterType) {
      case 'onboardedOn':
        patientFilter.filter.onboardedOn = {
          start: toTruentityDateInput(value),
          end: toTruentityDateInput(value2)
        };
        break;
      case 'organization':
        patientFilter.filter.organization = value;
        break;
      default:
        break;
    }
  });

  return patientFilter;
}

/** Converts a list of saved filter templates into the patient list's filter shape. */
export function transformAllToPatientFilter(templates: FilterTemplate[]): PatientFilter[] {
  return templates?.map(t => transformToPatientFilter(t));
}

/** Converts a patient list filter back into the input shape the API expects when saving it. */
export function transformToPatientListToolbarFilter(filter: PatientFilter): FilterInputData[] {
  const filterInputData: FilterInputData[] = [];
  if (filter.filter?.onboardedOn) {
    const { start, end } = filter.filter.onboardedOn;

    filterInputData.push({
      filterType: 'onboardedOn',
      operatorType: 'between',
      value: (start || end || '').toString(),
      value2: end?.toString()
    });
  }

  if (filter.filter.organization) {
    filterInputData.push({
      filterType: 'organization',
      operatorType: 'is',
      value: filter.filter.organization
    });
  }
  return filterInputData;
}
